import { render, staticRenderFns } from "./AcceptEmailInvitation.vue?vue&type=template&id=2951b3d2&scoped=true&"
import script from "./AcceptEmailInvitation.vue?vue&type=script&lang=js&"
export * from "./AcceptEmailInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AcceptEmailInvitation.vue?vue&type=style&index=0&id=2951b3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951b3d2",
  null
  
)

export default component.exports